module.exports = __webpack_public_path__ + "img/coupon.ae1c2295.svg";